import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../authentication/authentication.service';
import { AppSettingService } from '../services/app-setting.service';
import { CustomLoadingService } from '../shared/custom-loading/custom-loading.service';

@Component({
  selector: 'app-coachinghub',
  templateUrl: './coachinghub.component.html',
  styleUrls: ['./coachinghub.component.css']
})
export class CoachinghubComponent implements OnInit {
  title: any = "coachinghub";
  url: any;
  constructor(private appSettingService:AppSettingService , private customLoadingService: CustomLoadingService,
    private authenticationService:AuthenticationService) { }
  isIndividualProvider: any = false;
  loggedInUser: any = [];
  ngOnInit() {
  // this.RedirectURL();
  }

  RedirectURL()
  {
    this.customLoadingService.show();
       this.loggedInUser = this.appSettingService.loggedInUser;
    this.authenticationService.getBHSSOUrl(this.loggedInUser.ProviderId).subscribe(response => {
      console.log(response.CoachingHubURL);
      // if (response.Status != undefined && response.Status == 1) {

      //   if (response && response.CoachingHubURL) {
  
          /****************adding user information to localStorage*******************/
         
          if (response.CoachingHubURL != "") {
            this.url=response.CoachingHubURL;
            console.log(this.url);
            window.open(this.url, '_blank');
          }
         
     // }
   // }
  //  this.customLoadingService.show();
  },
      () => {

        this.customLoadingService.hide();
      
      },
      () => {
        this.customLoadingService.hide();
       
      });;

  }

  
}